import http from '../../utils/services/http';
import { GetTagsRequestParams } from '../../../common/api/tags/tagRouteTypes';

export const fetchTagsFromDb = async (params: GetTagsRequestParams = {}) => {
    const response = await http({
        method: 'get',
        url: `tags`,
        params,
    });

    return response.data.tags;
};

export const getElementsByTagId = async (tagId: string) => {
    const response = await http({
        method: 'get',
        url: `tags/${tagId}/elements`,
    });

    return response.data.elements;
};
